module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-left-square-cce65f9c.svg";